import React from "react";
import { CheckCircle, Building2, PhoneCall } from "lucide-react";
import { useNavigate } from "react-router-dom";

const features = [
  "Four-tier underground parking stack with independent access",
  "Maximizes parking capacity in minimal surface area",
  "Ideal for premium residential, commercial, and institutional sites",
  "Fully automated lift & slide mechanism",
  "Safe, secure, and weather-protected parking solution",
];

const applications = [
  "High-rise Residential Towers",
  "Luxury Commercial Complexes",
  "Hospitals with High Visitor Flow",
  "Urban Hotels with Limited Land",
  "Government or Smart City Projects",
];

const FourLevelPitParkingDetail = () => {
    const navigate = useNavigate()
  return (
    <section className="about-wrapper">
      {/* Hero */}
      <div className="about-hero">
        <div className="hero-content">
          <h1>4 Level Pit Parking System</h1>
          <p>
            A high-capacity underground parking system designed to stack four levels of cars efficiently — without using surface space. Ideal for premium real estate where land is limited but parking demand is high.
          </p>
        </div>
      </div>

      {/* Description */}
      <div className="about-section">
        <h2>What is 4 Level Pit Parking?</h2>
        <p>
          4 Level Pit Parking is a fully automated underground parking system that allows vehicles to be parked in four vertical layers below ground level. Vehicles are moved vertically and horizontally using lift-and-slide mechanisms to the designated slot and retrieved independently without moving others.
        </p>
        <p>
          The system is best suited for locations with extremely limited ground area and high parking demand. It ensures efficient space usage, minimal visual clutter, and secure vehicle storage in premium projects.
        </p>
      </div>

      {/* Features */}
      <div className="about-section">
        <h2>Key Features & Benefits</h2>
        <ul className="lt-puzzle-list">
          {features.map((item, index) => (
            <li key={index}><CheckCircle size={18} /> {item}</li>
          ))}
        </ul>
      </div>

      {/* How it Works */}
      <div className="about-section">
        <h2>How It Works</h2>
        <p>
          Cars are driven onto an entry platform at ground level. The system uses motorized lifts to lower the car into a vacant underground slot — up to four levels deep. A central control unit manages all platform movements ensuring accurate, collision-free positioning.
        </p>
        <p>
          The system operates on PLC logic, using sensors, limit switches, and safety locks to guarantee precision and user safety. Retrieval is seamless and quick, even at full capacity.
        </p>
      </div>

      {/* Applications */}
      <div className="about-section">
        <h2>Best Suited For</h2>
        <ul className="lt-puzzle-list">
          {applications.map((item, index) => (
            <li key={index}><Building2 size={18} /> {item}</li>
          ))}
        </ul>
      </div>

      {/* Call to Action */}
      <div className="lt-puzzle-cta">
        <div className="lt-puzzle-cta-content">
          <h3>Need 4 Level Pit Parking for your property?</h3>
          <p>Contact LIFTECH ENGINEERING PVT. LTD. today to get site analysis and system consultation by our engineers.</p>
          <button className="lt-puzzle-contact-btn" onClick={() => navigate("/get-started")}>
            <PhoneCall size={18} /> Request Consultation
          </button>
        </div>
      </div>
    </section>
  );
};

export default FourLevelPitParkingDetail;
